module.exports = __webpack_public_path__ + "img/e05655f0a7e2414a9282d67afaa3a32a-1024.59fa2a46.jpg";